import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { BTitle, BText, BLink } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../hoc'
import { isMobileDevice } from '../../utils/device'
import { SUPPORT_PHONE } from '../../constants/commonConstants'
import { URL } from '../../constants'
import err404Icon from '../../assets/err404.svg'
import messages from '../../i18n'
import phoneIcon from '../../assets/phoneRinging.svg'
import styles from './styles.scss'

interface Props extends IntlInterface {
  isMobileDevice: () => boolean
}

export const NotFound: React.FunctionComponent<Props> = (props: Props) => (
  <div className={styles.container}>
    <img src={err404Icon} alt="" className={styles.coverImg} />
    <BTitle type="h4" center>
      {props.translate(messages.NotFound.title)}
    </BTitle>
    <BText type="primary">{props.translate(messages.NotFound.mainMessage)}</BText>
    {props.isMobileDevice && (
      <BText type="secondary">
        {props.translate(messages.NotFound.newLoan)}
        <BLink href={URL.MONETA_HOMEPAGE} theme={styles.textLink}>
          {URL.MONETA_HOMEPAGE}
        </BLink>
      </BText>
    )}
    <hr className={styles.hr} />
    <BText theme={styles.moreInfo}>{props.translate(messages.NotFound.moreInfo)}</BText>
    <img src={phoneIcon} alt="" className={styles.callIcon} />
    <BText type="notice" theme={styles.call}>
      {props.translate(messages.NotFound.call)}
    </BText>
    <BLink href={`tel:${SUPPORT_PHONE}`} theme={styles.callLink}>
      {SUPPORT_PHONE}
    </BLink>
  </div>
)

export default compose(
  connect(null, {
    isMobileDevice,
  }),
  intl
)(NotFound)
